import { render, staticRenderFns } from "./ConditionsDistribute.vue?vue&type=template&id=22d89632&scoped=true&"
import script from "./ConditionsDistribute.vue?vue&type=script&lang=js&"
export * from "./ConditionsDistribute.vue?vue&type=script&lang=js&"
import style0 from "./ConditionsDistribute.vue?vue&type=style&index=0&id=22d89632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d89632",
  null
  
)

export default component.exports